/* eslint-disable no-undef */
const useScopeVars = () => {
  const scopeElement = document.getElementById("scope")
  const csrfElement = document.querySelector('meta[name="csrf-token"]')

  // Return default values if elements aren't found
  if (!scopeElement) {
    console.warn("Scope element not found in the DOM. Using default values.")
    return {
      dataSpaceSlug: "",
      organizationSlug: "",
      projectId: "",
      projectName: "",
      csrfToken: csrfElement?.content || "",
      bearerToken: ""
    }
  }

  return {
    dataSpaceSlug: scopeElement.dataset.scopeDataSpaceSlugValue,
    organizationSlug: scopeElement.dataset.scopeOrganizationIdValue,
    projectId: scopeElement.dataset.scopeProjectIdValue,
    projectName: scopeElement.dataset.scopeProjectNameValue,
    csrfToken: csrfElement?.content || "",
    bearerToken: scopeElement.dataset.scopeOrgAuthToken
  }
}

export default useScopeVars
